import React from 'react';

interface IOwnProps {
    checked?: boolean;
    disabled?: boolean;
    label?: string;
    labelBody?: string;
    labelHeadline?: string;
    modifierClass?: string;
    name: string;
    notice?: string | React.ReactNode;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    required?: boolean;
    textModifier?: string;
    value?: string;
}

type Props = IOwnProps;

class FormCheckbox extends React.Component<Props, {}>{
    public render() {
        return (
            <div className={'form__field form__field--checkbox ' + (this.props.modifierClass) + (this.props.disabled ? ' is-disabled' : '') + (this.props.required ? ' is-required' : '')}>
                <label className="form__label">
                    <input className="form__item" value={this.props.value || ''} name={this.props.name} type="checkbox" disabled={this.props.disabled} checked={this.props.checked} onChange={this.handleChange} />
                    <span className={'form__label__text' + (this.props.textModifier ? ' form__label__text' + this.props.textModifier : '')}>
                        {this.props.label &&
                            <span>{this.props.label}&nbsp;&nbsp;<strong>&#10033;</strong></span>
                        }
                        {this.props.labelHeadline &&
                            <h5>{this.props.labelHeadline}</h5>
                        }
                        {this.props.labelBody &&
                            <p>{this.props.labelBody}&nbsp;&nbsp;<strong>&#10033;</strong></p>
                        }
                        <svg className="svg-icon svg-icon--checkmark">
                            <use xlinkHref="/dist/svg/svg-sprite.svg#checkmark" />
                        </svg>
                    </span>
                </label>
                {this.props.notice &&
                    <span className="form__notice">{this.props.notice}</span>
                }
            </div>
        );
    }

    private handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.persist();

        if (this.props.onChange) {
            this.props.onChange(e);
        }
    };
}

export default FormCheckbox;